import { computed, ref } from 'vue';

export function useFeedbackBar() {
  const feedbackBar = computed(
    () => document.getElementsByClassName('feedbackNew')[0]
  );
  const feedbackBarTimeout = ref(null);

  function show(message, state = 'tw-bg-success-light') {
    if (!feedbackBar.value) return;

    const shortlistInSearchEnabled = feedbackBar.value.classList.contains(
      'shortlist-added-notification-enabled'
    );

    if (
      shortlistInSearchEnabled &&
      (state === 'tw-bg-success-light' ||
        message === 'Removed from your shortlist')
    ) {
      return;
    }

    feedbackBar.value.innerText = message;
    feedbackBar.value.classList.remove(
      'tw-bg-success-light',
      'tw-bg-primary-grey'
    );
    feedbackBar.value.classList.add(state);
    feedbackBar.value.classList.remove('tw-hidden');

    // Reset feedback bar animation
    if (feedbackBarTimeout.value) {
      feedbackBar.value.style.animation = 'none';
      feedbackBar.value.offsetHeight; // Trigger reflow
      feedbackBar.value.style.animation = null; // Reset to stylesheet-set animation

      clearTimeout(feedbackBarTimeout.value);
      feedbackBarTimeout.value = null;
    }

    feedbackBarTimeout.value = setTimeout(
      () => feedbackBar.value.classList.add(state, 'tw-hidden'),
      2 * 1000
    );
  }

  return {
    show,
  };
}
